import { SmileySadIcon } from '@phosphor-icons/react';
import { Box, toRem, config, Text } from 'folds';

function GifSearching() {
  return (
    <Box
      style={{ padding: `${toRem(60)} ${config.space.S500}` }}
      alignItems="Center"
      justifyContent="Center"
      direction="Column"
      gap="300"
    >
      <Text>Loading GIFs...</Text>
    </Box>
  );
}

function GifSearchError({ error }: { error: string }) {
  return (
    <Box
      style={{ padding: `${toRem(60)} ${config.space.S500}` }}
      alignItems="Center"
      justifyContent="Center"
      direction="Column"
      gap="300"
    >
      <Text>Error: {error}</Text>
    </Box>
  );
}

function NoGifResults() {
  return (
    <Box
      style={{ padding: `${toRem(60)} ${config.space.S500}` }}
      alignItems="Center"
      justifyContent="Center"
      direction="Column"
      gap="300"
    >
      <SmileySadIcon size="48" />
      <Box direction="Inherit">
        <Text align="Center">No GIFs found!</Text>
        <Text priority="300" align="Center" size="T200">
          Try searching for something else or favoriting some gifs.
        </Text>
      </Box>
    </Box>
  );
}

type GifStatusProps = {
  loading: boolean;
  error: string | null;
  isEmpty: boolean;
};

export function GifStatus({ loading, error, isEmpty }: Readonly<GifStatusProps>) {
  if (loading) return <GifSearching />;
  if (error) return <GifSearchError error={error} />;
  if (isEmpty) return <NoGifResults />;
  return null;
}
